import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useTelemedicineStore = defineStore({
    id: 'telemedicine',
    state: () => ({
        eggDescList: [
            {
                eggIconObj: { componentName: 'telemedicine', imgName: 'calendar', imgFormat: 'svg', width: '4.6vw' },
                label: 'telemedicine.appointmentDesc'
            },
            {
                eggIconObj: { componentName: 'telemedicine', imgName: 'computer', imgFormat: 'svg', width: '6vw' },
                label: 'telemedicine.conductConsolDesc'
            },
            {
                eggIconObj: { componentName: 'telemedicine', imgName: 'medicine', imgFormat: 'svg', width: '5.9vw' },
                label: 'telemedicine.certificateMedicationDesc'
            }
        ],
        teleconsultationsDesc: 'To meet the needs of our patients in these unprecedented times, we provide professional </br> teleconsultation services to allow our patients to seek out medical advice in the comfort and security </br>of their home. See a doctor, get online prescriptions, or obtain a medical certificate with ease.',
        teleconsultationProvideList: [
            'telemedicine.teleconsultationProvideDesc',
            '#',
            'telemedicine.teleconsultationProvideDesc2'
        ],
        teleconsultationForMeList: [
            'telemedicine.teleconsultationForMeP1',
            'telemedicine.teleconsultationForMeP2',
            'telemedicine.teleconsultationForMeP3',
            'telemedicine.teleconsultationForMeP4',
            'telemedicine.teleconsultationForMeBullet1',
            'telemedicine.teleconsultationForMeBullet2',
            'telemedicine.teleconsultationForMeBullet3',
            'telemedicine.teleconsultationForMeBullet4',
            'telemedicine.teleconsultationForMeBullet5',
            'telemedicine.teleconsultationForMeBullet6',
        ],
        teleconsultataionBottomList: [
            'telemedicine.teleconsultataionBottomList1',
            'telemedicine.teleconsultataionBottomList2',
            'telemedicine.teleconsultataionBottomList3',
        ]
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTelemedicineStore, import.meta.hot));
}

export { useTelemedicineStore };
